
import {supportNative, getErrorFactory, logError} from './util';
import toastH5 from '../components/Toast';

const zzc = window.zzc;


export default function toast(content, time = 2000) {
  return new Promise(function (resolve, reject) {
    let errorFactory = getErrorFactory('toast');

    if (supportNative('alert')) {
      zzc.call('alert', {
        content: content,
        time: time,
        complete: function (res) {
          if (res.state) {
            logError(errorFactory(res.message));
          }
        }
      });
    } else {
      toastH5(content, time);
      resolve(true);
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/toast.js